import { Instrument } from "@ts/types/instrument.type"
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@components/dataDisplay/table/Table"
import styles from "./premarket.module.css"

const InstrumentsTable = ({ instruments }: { instruments: Instrument[] }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Basiswert</TableHeaderCell>
          <TableHeaderCell align="right" hideOnMobile={true}>
            Size
          </TableHeaderCell>
          <TableHeaderCell align="right">Geld</TableHeaderCell>
          <TableHeaderCell align="right">Brief</TableHeaderCell>
          <TableHeaderCell align="right" className={styles.hide}>
            Size
          </TableHeaderCell>
          <TableHeaderCell align="right" hideOnMobile={true}>
            Change
          </TableHeaderCell>
          <TableHeaderCell align="right">%</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {instruments.map((instrument: Instrument) => (
          <TableRow key={instrument.shortName}>
            <TableCell shortenOnMobile={true}>{instrument.shortName}</TableCell>
            <TableCell align="right" hideOnMobile={true}>
              {instrument.bidSize}
            </TableCell>
            <TableCell align="right" className={styles.bold}>
              {instrument.bid}
            </TableCell>
            <TableCell align="right" className={styles.bold}>
              {instrument.ask}
            </TableCell>
            <TableCell align="right" hideOnMobile={true}>
              {instrument.askSize}
            </TableCell>
            <TableCell
              align="right"
              hideOnMobile={true}
              numberType={`${instrument.change.startsWith("-") ? "negative" : "positive"}`}
            >
              {instrument.change}
            </TableCell>
            <TableCell
              align="right"
              numberType={`${instrument.changePercent.startsWith("-") ? "negative" : "positive"}`}
            >
              {instrument.changePercent}%
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default InstrumentsTable
